export const ident = ['name', 'viewport', 'browserName', 'os', 'app', 'branch'];
